import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',  // When using standalone components, we use 'root' to ensure that the interceptor is available app-wide.
})
export class AuthInterceptor implements HttpInterceptor {

  /**
   * References:
   * - Using local storage in Angular
   *    https://stackoverflow.com/questions/78581964/how-to-use-localstorage-in-angular-18-httpinterceptorfn
   */

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url.indexOf("graph.microsoft.com") >= 0) return next.handle(req);
    
    let authToken: any = {};
    authToken = localStorage.getItem("authToken");

    if(authToken != null){
      authToken = "Bearer " + authToken;
    
      // Clone the request to add the custom header
      const modifiedReq = req.clone({
        setHeaders: {
          'Authorization': authToken,
          'X-Api-Key': environment.apiKey 
        },
      });

      // Pass the modified request to the next handler
      return next.handle(modifiedReq);
    }

    else return next.handle(req);
  }
}
